<div class="unsaved-changes-dialog-container">
    <h2 class="title">{{ data.title }}</h2>

    <p>{{ data.message }}</p>

    <div class="actions">
        <button mat-button (click)="stay()">
            {{ data.cancelButtonLabel }}
        </button>

        <button mat-raised-button color="warn" (click)="leave()">
            {{ data.confirmButtonLabel }}
        </button>
    </div>
</div>